import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput, DropdownInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const SalesBasic = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.salesdetail"));
  const inflationOptions = _.map(props.namedItems['inflation'], (i) => { return {label: i.code, value: i.inflationid} })

  const emptyRecord = {
    amt: null,
    amtType: props.defaults["salesAmtType"],
    inflation: {
      inflationMode: "namedItem",
      inflationNamedItemId: _.get(props, "defaults.salesInflation.inflationNamedItemId")
    }
  }

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)

    if(field === "inflationNamedItemId") {
      _.set(nextData, "inflation", {
        inflationMode: "namedItem",
        inflationNamedItemId: val
      })
    } else {
      _.set(nextData, field, val)
    }

    delete nextData.items

    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'salesdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rentroll', props.field)(field)(props.rowData, props)

  return (
    <div style={{height: '300px'}}>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput
            field="amt"
            className="automated billion-input"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000000}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}/>
        </div>
        <div>
          <label>Amount Type</label>
          <DropdownInput
            field="amtType"
            className="automated"
            data={data}
            attrs={attrs}
            default={props.defaults['salesAmtType']}
            options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
            persist={updateData}/>
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput
            className="automated named-item-state-input"
            data={_.get(data, 'inflation')}
            default={_.get(props, "defaults.salesInflation.inflationNamedItemId")}
            attrs={attrs}
            field="inflationNamedItemId"
            filter={true}
            options={inflationOptions}
            persist={updateData}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default SalesBasic
